import { Button, Card } from 'antd';
import { Grid, SearchPanel, Table, TableHeaderRow, Toolbar, VirtualTable } from '@devexpress/dx-react-grid-material-ui';
import { IntegratedFiltering, SearchState } from '@devexpress/dx-react-grid';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import { actions } from './WorkOrderReference.redux';
import AddComponentForm from './AddComponentForm';
import ComponentQueue from './ComponentQueue';
import CopyTableDataToClipboard from '@/components/CopyTableDataToClipboard/copyTableDataToClipboard';
import { getTableColumnExtensions } from '@/lib/reactiveGridTableMethods'
import LoadingCover from '@/components/LoadingCover/LoadingCover';
import { modifyTableData } from '@/components/CopyTableDataToClipboard/modifyTableData'
import { PlusSquareOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';

const workOrderComponentTableColumns = [
	{
		title: '#',
		name: 'VisOrder',
		width: '60px',
	},
	{
		title: 'Part Number',
		name: 'ItemCode',
		width: '300px',
	},
    {
        title: 'Part Description',
        name: 'ItemName',
        width: '500px',
    },
	{
		title: 'Batch or S/N',
		name: 'BatchOrSN',
		width: '250px',
	},
	{
		title: 'Revision',
		name: 'Revision',
		width: '250px',
	},
	{
		title: 'Quantity Per Unit',
		name: 'BaseQty',
		width: '140px',
	},
    {
        title: 'Total Quantity',
        name: 'PlannedQty',
        width: '140px',
    },
	{
		title: 'Issued Quantity',
		name: 'IssueQuantity',
		width: '140px',
	},
	{
		title: 'Line Notes',
		name: 'LineNotes',
		width: '200px',
	},
	{
        title: 'Reference Designator',
        name: 'ReferenceDesignator',
    },
];


const WorkOrderComponentTable = () => {
    const dispatch        = useDispatch(),
        params            = useParams(),
        docNum            = params.docNum,
		savingChanges     = useSelector(state => state.workOrderReference.savingComponents),
        searchString      = useSelector(state => state.workOrderReference.componentSearchString),
        componentList     = useSelector(state => state.workOrderReference.componentList),
		newComponents     = useSelector(state => state.workOrderReference.newComponents),
		addingComponents  = useSelector(state => state.workOrderReference.addingComponents),
        componentsLoading = useSelector(state => state.workOrderReference.componentsLoading);

    useEffect(() => {
		dispatch(actions.loadItemList());
	}, [ dispatch ]);

    
    useEffect(() => {
        if (docNum) {
            dispatch(actions.loadWorkOrderComponents(docNum));
        }
    }, [ dispatch, docNum ]);


    const openAddComponentForm = () => {
		dispatch(actions.setState({ addingComponents: true }));
    };

    const setSearchValue = (value) => {
        if(componentsLoading) {
            return false;
        }
        dispatch(actions.setState({ componentSearchString: value }));
    };

	const submitNewComponents = () => {
		dispatch(actions.submitNewComponents());
	};

	const removeListComponent = (index) => {
		dispatch(actions.removeComponentRow(index));
	};

    const RowComponent = (props) => {
        return (
            <Table.Row
                key={props.tableRow.rowId}
                {...props}
            />
        );
    };

    const CellComponent = ({ ...props }) => {
        return (
            <Table.Cell
                {...props}
            >
            </Table.Cell>
        );
	};

    return (
		/*

			TODO Fix the way the component card displays (Two batches issued can cause the line the duplicate and look like more was issued than expected)

		*/
        <div>
            <Card
                className="ts_portal_card ts-portal-card-margin ts-portal-card-top"
                title="Components"
            >

                { 
                    componentsLoading && 
                    <LoadingCover />
                }

                <Grid
                    rows={componentList} 
                    columns={workOrderComponentTableColumns}
                >

                    <SearchState
                        onValueChange={setSearchValue}
                        value={searchString}
                    />

                    <IntegratedFiltering />

                    <VirtualTable
                        cellComponent={CellComponent}
                        rowComponent={RowComponent}
                        columnExtensions={getTableColumnExtensions(workOrderComponentTableColumns)}
                    />

                    <TableHeaderRow />

                    <Toolbar />

                    <CopyTableDataToClipboard
                        totalRows={componentList.length}
                        tableDataAsList={modifyTableData(workOrderComponentTableColumns,componentList)}
				    />

                    <SearchPanel />
                </Grid>


                <div className="ts_margin_top">
                    <Button
                        className="add_button_variant"
                        size="large"
						type="default"
						disabled={!docNum || componentsLoading || savingChanges}
                        onClick={(e) => {
                            openAddComponentForm();
                        }}
                    >
                            <PlusSquareOutlined /> Add New Component
                    </Button>


					{
						addingComponents &&
						<AddComponentForm />
					}

					{
						(newComponents.length > 0) &&
						<ComponentQueue 
							newComponents={newComponents}
							savingChanges={savingChanges}
							onSubmitComponents={submitNewComponents}
							onRemoveComponent={removeListComponent}
						/>
					}
				</div>
				
            </Card>
        </div>
    );
};

export default WorkOrderComponentTable;
